module.exports = __webpack_public_path__ + "static/img/13.8621f660.gif";